module.exports = __webpack_public_path__ + "7259b3b1c7d01b75e8833c9a1ea4f837.png";